<template>
    <div class="about-eight-section" v-if="about != null">
        <!-- <div class="about-section-top-baner">
            <div class="baner-img">
                <img :src="about.img_title" alt="">
            </div>
            <div class="baner-title">
                <h2>{{about.main_title.desc_light}}<br><span>{{about.main_title.desc_bold}}</span></h2>
            </div>
        </div> -->
        <div class="mobile-title">
            <h2>{{about.main_title.desc_light}}<br><span>{{about.main_title.desc_bold}}</span></h2>
        </div>
        <div class="container">
            <div class="about-eight-promo-pic">
                <img :src="about.img_title" alt="">
            </div>
            <div class="about-eight-promo-title">
                <h2>{{about.main_title.desc_light}}<br><span>{{about.main_title.desc_bold}}</span></h2>
            </div>
            <div class="about-eight-section-items">
                <div class="item" v-for="(slide, index) in about.items" :key="index">
                    <div class="item-icon">
                        <img :src="slide.img" alt="">
                    </div>
                    <div class="item-title">
                        <h2>{{slide.title}}</h2>
                    </div>
                    <div class="desc">
                        <p v-for="desc in slide.desc">{{desc.text}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'about-eight-second',
        components: {
        },
        data () {
            return {
                swiperOption: {
                    speed: 600,
                    observer: true,
                    observeParents: true,
                    effect: 'slide',
                    direction: 'vertical',
                    // loop: false,
                    slidesPerView: 1,
                    // spaceBetween: 30,
                    pagination: {
                        el: '.about-eight-section-pagination',
                        type: 'fraction',
                    },
                    navigation: {
                        nextEl: '.about-eight-btn-next',
                        prevEl: '.about-eight-btn-prev',
                    }
                }
            }
        },
        methods: { 
            
        },
        computed: {
            about() {
                return this.$store.state.about.about_eigth_elem
            }
        },
        created () {
        },
        mounted () {
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/about/about-elems/about-elem-eight.scss';
    @import '@/styles/components/about/about-top-banner.scss';
    @import '@/styles/components/about/about-media/8-media.scss';
</style>